import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../styles/backgroundRenderer.scss';
import { getImageSrc } from '../helper/imageBlobCache';
import globalStore from '../store';
// All PDF cache logic lives in a store-agnostic helper so playerStore can also
// import it without creating a circular dependency (BackgroundRenderer →
// globalStore → playerStore → BackgroundRenderer).
import { preloadPdfBackground, getCachedPdfBackground, } from '../helper/pdfCache';
// Re-export so all existing callers (PlayerMainContainer, etc.) that import
// these from 'BackgroundRenderer' continue to work without changes.
export { preloadPdfBackground, getCachedPdfBackground, getPdfPageDimensions, } from '../helper/pdfCache';
var BackgroundRenderer = function (_a) {
    var file = _a.file, _b = _a.className, className = _b === void 0 ? '' : _b, pageWidth = _a.pageWidth, pageHeight = _a.pageHeight;
    // Seed synchronously from the resolved cache so revisiting a page shows the
    // PDF on the very first render instead of flashing blank for a microtask.
    var _c = useState(function () { var _a; return (_a = getCachedPdfBackground(file)) !== null && _a !== void 0 ? _a : null; }), imageUrl = _c[0], setImageUrl = _c[1];
    var setPdfBackgroundLoading = globalStore.useStoreActions(function (state) { return state.playerStore.setPdfBackgroundLoading; });
    useEffect(function () {
        var cancelled = false;
        var resolved = getCachedPdfBackground(file);
        if (resolved) {
            setImageUrl(resolved);
            return;
        }
        setImageUrl(null);
        setPdfBackgroundLoading(true);
        preloadPdfBackground(file).then(function (url) {
            if (cancelled)
                return;
            setImageUrl(url);
            setPdfBackgroundLoading(false);
        });
        return function () {
            cancelled = true;
            setPdfBackgroundLoading(false);
        };
    }, [file, setPdfBackgroundLoading]);
    return (_jsx("div", { className: "backgroundRenderer ".concat(className), style: {
            // Always centered in the mainHolder regardless of any saved
            // diffX/diffY: the PDF is the page's visual frame, so it should sit
            // dead-centre on the canvas no matter what coordinate system the
            // widgets were authored in.
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: pageWidth !== null && pageWidth !== void 0 ? pageWidth : '100%',
            height: pageHeight !== null && pageHeight !== void 0 ? pageHeight : '100%',
        }, children: imageUrl && (_jsx("img", { src: getImageSrc(imageUrl), alt: "background-preview", tabIndex: -1, draggable: false, onDragStart: function (e) { return e.preventDefault(); }, className: 'imageContainer' })) }));
};
export default BackgroundRenderer;
